<template>
  <div class="detail">
    <div class="right-bg"></div>
    <div class="message-info">
      <div class="top-box">
        <div class="top">
          <img class="index-box" src="@/assets/image/liuyan.png" alt="" />
          <div class="top-title">{{ replyInfo.leaveTitle }}</div>
          <div class="status" v-if="replyInfo.status == 1">
            待回复
          </div>
          <div class="status status1" v-if="replyInfo.status == 2">
            待审核
          </div>
          <div class="status status2" v-if="replyInfo.status == 3">
            已完成（已发布）
          </div>
        </div>
        <div class="center">{{ replyInfo.leaveContent }}</div>
        <div class="bottom">
          <div class="bottom-item">
            <img src="@/assets/image/sj.png" alt="" />
            <div style="margin: 0 8px;color: #92979c;">建议时间</div>
            <div>{{ replyInfo.createTime }}</div>
          </div>
          <div class="bottom-item">
            <img src="@/assets/image/wz.png" alt="" />
            <div style="margin: 0 8px;color: #92979c;">点位</div>
            <div>
              {{ replyInfo.pointName }}
            </div>
          </div>
        </div>
      </div>
      <div class="info-box" v-if="isShow">
        <div class="info-top">
          <div class="person-info">
            <img
              style="height: 40px; margin-right: 8px;"
              src="@/assets/image/zxr.png"
              alt=""
            />
            <div
              style="font-family: MiSans, MiSans;
                   font-weight: 700;
                   font-size: 16px;
                   color: #494C4F;
                   margin-right: 27px;"
            >
              {{ replyInfo.respondentName }}
            </div>
            <img
              style="height: 18px; margin-right: 4px;"
              src="@/assets/image/bumen.png"
              alt=""
            />
            <div
              style="font-size: 14px;
                   color: #494C4F;"
            >
              {{ replyInfo.respondentDeptName }}
            </div>
          </div>
          <div
            v-if="this.replyInfo.status != 1"
            style="font-size: 14px;color: #92979C;"
          >
            {{ replyInfo.replyTime }} 回复
          </div>
        </div>
        <el-input
          v-if="replyInfo.status == 1"
          type="textarea"
          show-word-limit
          style="white-space: pre-wrap;"
          ref="replyContent"
          maxlength="2000"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model="replyContent"
          placeholder="请输入"
        ></el-input>
        <div class="replyContent-box" v-else>
          {{ replyInfo.replyContent }}
        </div>
        <div
          class="info-bottom"
          v-if="replyInfo.status == 1 || (!isDetail && replyInfo.status == 2)"
        >
          <div>
            <span
              v-if="replyInfo.status == 2"
              style="
                    font-weight: 700;
                    font-size: 20px;
                    color: #494C4F;"
              >意见审核</span
            >
          </div>
          <div v-if="replyInfo.status == 1">
            <el-button @click="replyPointLeaveMessageFun" class="search"
              >提交</el-button
            >
          </div>
          <div v-if="replyInfo.status == 2">
            <el-button @click="updatePointLeaveMessageByIdFun(4)" class="reset"
              >审核不通过</el-button
            >
            <el-button @click="updatePointLeaveMessageByIdFun(3)" class="search"
              >审核通过</el-button
            >
          </div>
        </div>
      </div>
      <div class="info-box info-box2" v-else>
        <div class="empty-box">
          <img style="height: 126px;" src="@/assets/image/xwsj.png" alt="" />
          <div class="text">暂无答复</div>
          <div class="text2">
            点击<el-button
              @click="isShow = true"
              style="height: 20px;padding: 0;"
              type="text"
              >答复留言</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="back-box" @click="back">
      <i style="color: #92979C;font-size: 18px;" class="el-icon-arrow-left"></i>
    </div>
  </div>
</template>

<script>
import {
  getPointLeaveMessageById,
  replyPointLeaveMessage,
  updatePointLeaveMessageById
} from "@/api/block.js";
export default {
  props: {
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      replyContent: "",
      replyInfo: {},
      isShow: true,
      userInfo: {}
    };
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.getPointLeaveMessageByIdFun();
  },
  methods: {
    back() {
      this.$emit("update:dialogVisible", false);
    },
    async getPointLeaveMessageByIdFun() {
      const res = await getPointLeaveMessageById({
        id: this.curItem.id
      });
      this.replyInfo = res.data.data;
      if (this.replyInfo.status == 1 && !this.replyInfo.replyContent) {
        this.replyInfo.respondentName = this.userInfo.userName;
        this.replyInfo.respondentDeptName = this.userInfo.deptName;
        if (this.isDetail) this.isShow = false;
      }
    },
    // 答复
    async replyPointLeaveMessageFun() {
      const res = await replyPointLeaveMessage({
        id: this.curItem.id,
        replyContent: this.replyContent
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "答复成功"
        });
        this.$emit("refreshList");
        this.back();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 审核网格留言（通过-不通过）
    async updatePointLeaveMessageByIdFun(status) {
      const res = await updatePointLeaveMessageById({
        id: this.curItem.id,
        status: status
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "审核成功"
        });
        this.$emit("refreshList");
        this.back();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.detail {
  background: linear-gradient(180deg, #e0eeff 0%, rgba(255, 255, 255, 0) 100%)
    no-repeat;
  background-size: 100% 160px;
  padding: 30px 0 24px 0;
  display: flex;
  justify-content: center;
  position: relative;
  .right-bg {
    position: absolute;
    width: 158px;
    height: 133px;
    top: 36px;
    right: 36px;
    background: url("~@/assets/image/ly.png") center center no-repeat;
    background-size: 100% 100%;
  }
  .message-info {
    height: 100%;
    width: 1008px;
    .top-box {
      margin-top: 30px;
      .top {
        display: flex;
        align-items: center;
        .index-box {
          height: 24px;
          margin-right: 10px;
        }
        .top-title {
          font-family: MiSans, MiSans;
          font-weight: 700;
          font-size: 20px;
          color: #494c4f;
          margin-right: 12px;
        }
        .status {
          background: rgba(138, 144, 154, 0.09);
          border-radius: 2px;
          padding: 2px 6px;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;
          color: #92979c;
        }
        .status1 {
          background: rgba(255, 139, 70, 0.1);
          color: #ff8b46;
        }
        .status2 {
          background: rgba(12, 206, 179, 0.1);
          color: #00ac94;
        }
      }
      .center {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #494c4f;
        margin-top: 8px;
      }
      .bottom {
        display: flex;
        align-items: center;
        margin-top: 8px;
        .bottom-item {
          display: flex;
          align-items: center;
          margin-right: 56px;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;

          color: #494c4f;
          img {
            height: 15px;
          }
        }
      }
    }
    .info-box {
      width: 100%;
      height: calc(100% - 150px);
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      margin-top: 24px;
      position: relative;
      .info-top,
      .info-bottom {
        // position: absolute;
        // left: 0;
        height: 72px;
        width: 100%;
        padding: 16px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .info-top {
        // top: 0;
        border-bottom: 1px solid #e0e0e0;
        .person-info {
          display: flex;
          align-items: center;
        }
      }
      .info-bottom {
        // bottom: 0;
        border-top: 1px solid #e0e0e0;
      }
    }
    .info-box2 {
      display: flex;
      align-items: center;
      justify-content: center;
      .empty-box {
        width: 160px;
        height: 172px;
        .text {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 14px;
          color: #494c4f;
          text-align: center;
          margin-top: 8px;
        }
        .text2 {
          margin-top: 8px;
          text-align: center;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 13px;
          color: #92979c;
        }
      }
    }
  }
  .back-box {
    position: absolute;
    top: 24px;
    left: 36px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    border: 1px solid #d9dcde;
    cursor: pointer;
  }
}
/deep/.el-textarea,
.replyContent-box {
  min-height: calc(100% - 144px) !important;
  max-height: calc(100% - 144px) !important;
  height: calc(100% - 144px) !important;
  border: none;
}
/deep/.el-textarea__inner {
  min-height: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  border: none;
}
.replyContent-box {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  padding: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/streetInfo/message/components/detail.vue